const clamp = (value, min, max) => {
  let clamped = value
  if (!isNaN(min)) {
    clamped = Math.max(clamped, min)
  }

  if (!isNaN(max)) {
    clamped = Math.min(clamped, max)
  }

  return clamped
}

export default clamp
